export default `{
  'type': _type,
  'subheading': subheading,
  'heading': heading,
  'briefParagraph': briefParagraph,
}`;
